<div #datePickerContainer class="date-picker-container width-iner" fxLayout="row" fxLayoutAlign="space-around center">
  <div *ngIf="showDatePicker">
    <input
      type="text"
      #dateInput
      class="form-control hidden-picker"
      [ngClass]="{
        'hidden-picker-dropVar-bottom': dropsVar === 'down',
        'hidden-picker-dropVar-top': dropsVar !== 'down',
      }"
      [class.float-right]="sideOpening === 'left'"
      style="box-shadow: none; text-overflow: ellipsis; overflow: hidden; white-space: nowrap"
      readonly
      ngxDaterangepickerBootstrap
      [(ngModel)]="selected"
      [drops]="dropsVar"
      [opens]="sideOpening"
      [locale]="localeTime"
      [ranges]="showRanges ? ranges : {}"
      [showCustomRangeLabel]="false"
      [showCancel]="true"
      [linkedCalendars]="true"
      [showWeekNumbers]="true"
      [alwaysShowCalendars]="true"
      [showRangeLabelOnInput]="false"
      [keepCalendarOpeningWithRange]="true"
      (datesUpdated)="dayIsSelected($event)"
      [minDate]="formatedMinDate"
      [maxDate]="formatedMaxDate"
    />
  </div>

  @if (!fusionnedInput) {
    <div class="container">
      <div class="input-wrapper box-shadow">
        <input
          type="text"
          placeholder="Date de début"
          [value]="selected.startDate?.format('DD/MM/YYYY')"
          readonly
          (click)="triggerPicker()"
          class="date-input left"
        />
        <mat-icon matSuffix class="input-icon" (click)="triggerPicker()">today</mat-icon>
      </div>

      <div class="box-shadow">
        <input
          type="text"
          placeholder="Date de fin"
          [value]="selected.endDate?.format('DD/MM/YYYY')"
          readonly
          (click)="triggerPicker()"
          class="date-input right"
        />
      </div>
    </div>
  } @else {
    <div class="fused-container">
      <div class="fused-input-wrapper" [ngClass]="{ 'disabled-background': isDisablePicker }">
        <input
          type="text"
          #fusedDateInput
          [value]="formattedDateRange"
          readonly
          (click)="triggerPicker()"
          class="fused-date-input"
          [ngClass]="{ 'disabled-background': isDisablePicker }"
          [readOnly]="isDisablePicker"
        />
        <mat-icon class="fused-input-icon" (click)="triggerPicker()">today</mat-icon>
        <div class="date-range-tooltip">
          {{ formattedDateRange }}
        </div>
      </div>
    </div>
  }

  @if (calendarIsOpen) {
    <div class="overlay" (click)="closePicker()"></div>
  }
</div>
